'use strict';

var GridCustomSortFunctionsService = function GridCustomSortFunctionsService(optWeekService) {
  var sortModifier;
  function getCustomSort(field, modifier) {
    sortModifier = modifier;
    switch (field) {
      case 'dayOfWeek':
      case 'dow':
        return dayOfWeekSortingFunction(field);
      default:
        return null;
    }
  }
  function dayOfWeekSortingFunction(field) {
    return function dayOfWeekSortingFunction(row) {
      var sortOrder = -100; //default is bigger than 6 to put empty row at the top in case of sorting after adding new empty row
      if (row[field]) {
        sortOrder = parseInt(sortModifier + optWeekService.getIndexOfDayOfWeek(row[field]));
      }
      return sortOrder;
    };
  }
  return {
    getCustomSort: getCustomSort
  };
};
GridCustomSortFunctionsService.$inject = ['OptWeekService'];
module.exports = GridCustomSortFunctionsService;